export const START_SETTLEMENT = {
  ROOT: '/startSettlement',
};
